<script>
    /* eslint-disable */
	import { onMount } from 'svelte';
    
    let camera, scene, renderer, mesh;
    
    function init() {
        renderer = new THREE.WebGLRenderer({canvas: document.querySelector('#canvas'), alpha: true});
        renderer.setClearColor( 0xffffff, 0 );
        camera = new THREE.PerspectiveCamera(48, 1, 1, 100);
        camera.position.z = 25;
        scene = new THREE.Scene();
        const geometry = new THREE.SphereGeometry(10, 100, 100);
        const material = new THREE.MeshPhongMaterial({ opacity: 0});
        // material.map = new THREE.TextureLoader().load('media/earthmap1k.jpg')
        material.map = new THREE.TextureLoader().load('/ui/earthmap-25-alpha.png');
        mesh = new THREE.Mesh(geometry, material);
        // mesh.rotation.x += 0.5
        scene.add(mesh);

        const light1 = new THREE.AmbientLight(0xffffff);
        light1.position.set(100, 50, 100);
        scene.add(light1);
    }
    
    function resize() {
        const width = renderer.domElement.clientWidth;
        const height = renderer.domElement.clientHeight;
        renderer.setSize(width, height, false);
        camera.aspect = width / height;
        camera.updateProjectionMatrix(); 
    }
    
    function animate() {
        resize();
        mesh.rotation.y += 0.005;
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
    }
    
    onMount(() => {
        const ct = setInterval(() => {
            try {
                if (THREE) {
                    clearInterval(ct);
                    init();
                    animate();
                }
            } catch (err) {}
        });
    });

</script>

<canvas id="canvas" class="canvas" width="400" height="300"></canvas>

<style>
    .canvas {
        position:absolute;
        width: 10rem;
        height: 10rem;
        background-color:rgba(0,0,0,0);
    }
</style>
